<template>
    <v-list-item>
        <v-list-item-content class="filter-empty-message-list-item">
            {{ t_no_data_to_show }}
        </v-list-item-content>
    </v-list-item>
</template>
<script>
import '../../../../../prototypeExtensions/String';

export default {
    name: 'filter-empty-message',
    data() {
        return {
            t_no_data_to_show: Lang.langGet('No data to show.').removeDotsAtEnd()
        };
    }
};
</script>

<style>
.filter-empty-message-list-item {
    font-style: italic;
    user-select: none;
    pointer-events: none;
}
</style>
